export const Z_INDEX = {
  MODAL_WITH_HEADER_BASE: 10, // ヘッダー付きモーダルの基本z-index
  PROFILE_IMAGE_EDIT_MODAL: 15, // 他のヘッダー付きモーダルよりも上に表示する
  MODAL_BASE: 20, // 通常のモーダルの基本z-index（最前面）
} as const;
